import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Row, Col, Typography, Space, Select, Flex, Spin, Card } from 'antd';
import {
  ContactsTwoTone,
  MailOutlined,
  // MessageTwoTone,
  HomeTwoTone,
  ReconciliationTwoTone,
  DollarTwoTone,
  EnvironmentTwoTone,
} from '@ant-design/icons';
import { useIntl } from 'react-intl';
import ChartCard from '../../components/Dashboard/ChartCard';
import RecentActivity from '../../components/Dashboard/RecentActivity';
import Widget from '../../components/Widget';
import IntlMessage from '../../components/IntlMessage';
import dashboardApi from '../../api/home';
import { PUSHER_APP_KEY } from '../../utils/constant';
import Pusher from 'pusher-js';
import dayjs from 'dayjs';
import reportApi from '../../api/report';
import { useHistory } from 'react-router-dom';
import RevenueChart from './RevenueChart';
import {
  fillTemplate,
  formatDateTime,
  formatNumber,
} from '../../utils/helpers';
import LoadingContent from '../order/create/Loading';
import FilterBar from '../../components/FilterBar';
import operatorsApi from '../../api/operators';
import 'dayjs/locale/fr';

dayjs.locale('fr');
export const chartType = {
  REVENUE: 'revenue',
  PASSENGERS: 'passengers',
  FILLING_RATE: 'filling_rate',
  TRIPS: 'trips',
};
// import CardWithIcon from '../../components/CardWithIcon';
//import 'react-big-calendar/lib/css/react-big-calendar.css';
const { Text } = Typography;
const fs_16 = {
  fontSize: '16px',
};
const { Option } = Select;
export default function Home(props) {
  const intl = useIntl();

  const priceFormatter = new Intl.NumberFormat('en-US', {
    // style: "currency",
    // currency: "CFA",
    minimumFractionDigits: 0,
  });

  const [stats, setStats] = useState({
    total_bookings: 0,
    total_segments: 0,
    total_revenues: 0,
    total_seats: 0,
  });

  const [total, setTotal] = useState({
    day: {
      revenue: 0,
      total_seat: 0,
      total_count: 0,
      filling_rate: 0,
    },
    month: {
      revenue: 0,
      total_seat: 0,
      total_count: 0,
      filling_rate: 0,
    },
  });

  const authUser = useSelector((state) => state.auth.authUser);
  const [dataRecent, setDataRecent] = useState([]);
  const [loadingRecent, setLoadingRecent] = useState(false);
  const [refeshRecent, setRefeshRecent] = useState(false);
  const [loadingStats, setLoadingStats] = useState(false);

  const [operator, setOperator] = useState(null);
  const [operators, setOperators] = useState(null);
  const filterOperator = {
    page: 1,
    limit: 1000,
    order_by: 'id',
    order_dir: 'ASC',
  };
  useEffect(() => {
    const fetch = async () => {
      try {
        let operator = await operatorsApi.getAll(filterOperator);
        setOperators(operator.data);
      } catch (e) {
        console.error(e);
      } finally {
      }
    };
    fetch();
  }, []);

  useEffect(() => {
    const fetch = async () => {
      try {
        const filter = {
          page: 1,
          limit: 7,
          order_by: 'id',
          order_dir: 'DESC',
          keyword: '',
        };
        if (operator) {
          filter.filter_name = ['operator_id'];
          filter.filter_value = [operator];
        }
        setLoadingRecent(true);
        const res = await reportApi.getAllRecentActivity(filter);

        let data = res.data;

        const recentActivity = [];

        const dataTasks = data.map((task) => {
          const order = task?.description && JSON.parse(task?.description);
          let titleContent = null;

          if (task?.action === 'Create booking') {
            titleContent = (
              <>
                <>
                  <div className="gx-link" style={{ fontSize: '12px' }}>
                    {formatDateTime(order?.created_at)}
                  </div>
                  <span className="gx-link">
                    Nouvelle Réservation #{order?.order_no}
                  </span>{' '}
                  pour <span className="gx-link">{order?.operator?.title}</span>{' '}
                  a été créé
                </>
              </>
            );
          } else {
            titleContent = (
              <>
                <>
                  <div className="gx-link" style={{ fontSize: '12px' }}>
                    {formatDateTime(task?.createdAt)}
                  </div>
                  <span className="gx-link">
                    {fillTemplate(order?.text, {
                      id: order?.recordId || order?.body?.id,
                      from_date: order?.body?.from_date
                        ? dayjs(order?.body?.from_date).format('DD/MM/YY HH:mm')
                        : undefined,
                      to_date: order?.body?.to_date
                        ? dayjs(order?.body?.to_date).format('DD/MM/YY HH:mm')
                        : undefined,
                    })}
                  </span>
                </>
              </>
            );
          }

          return {
            id: task.id,
            name: '',
            title: [titleContent],
            avatar: null,
            imageList: [],
          };
        });

        recentActivity[0] = {
          id: 1,
          day: 'Today',
          tasks: dataTasks,
        };
        setDataRecent(recentActivity);
      } catch (e) {
        console.error(e);
      } finally {
        setLoadingRecent(false);
      }
    };
    fetch();
  }, [refeshRecent, operator]);
  const history = useHistory();
  const handleLoadMore = () => {
    history.push('/app/recent-activity');
  };
  useEffect(() => {
    Pusher.logToConsole = true;
    const pusher = new Pusher(PUSHER_APP_KEY, {
      cluster: 'ap1',
    });
    const channel = pusher.subscribe(`recentActivity`);
    channel.bind('recent_activity', async function (data) {
      setRefeshRecent(!refeshRecent);
    });
    return () => {
      channel.unbind('recent_activity');
      pusher.disconnect();
    };
  }, []);
  const cards = [
    {
      icon: <ReconciliationTwoTone />,
      title: intl.formatMessage({ id: 'global.orders' }),
      description: 'Manage your bookings and travelers',
      link: '/app/orders',
    },
    {
      icon: <EnvironmentTwoTone />,
      title: intl.formatMessage({ id: 'global.hops' }),
      description: 'Manage your hops',
      link: '/app/hops',
    },
    {
      icon: <HomeTwoTone />,
      title: intl.formatMessage({ id: 'global.destinations' }),
      description: 'Manage the destinations',
      link: '/app/destinations',
    },
    {
      icon: <ContactsTwoTone />,
      title: intl.formatMessage({ id: 'global.customers' }),
      description: 'Manage your customers',
      link: '/app/customers',
    },
    {
      icon: <DollarTwoTone />,
      title: intl.formatMessage({ id: 'global.revenue' }),
      description: 'Track your revenue indicators',
      link: '/app/reports/revenue',
    },
  ];

  useEffect(() => {
    const fetch = async () => {
      try {
        setLoadingStats(true);
        const res = await dashboardApi.getAll(operator);
        if (res) {
          setTotal(res);
          setLoadingStats(false);
        }
      } catch (err) {
        console.log(err);
      }
    };
    fetch();
  }, [operator]);

  const onFilter = (value) => {
    setOperator(value);
  };

  const [type, setType] = useState(chartType.REVENUE);
  const onChangeType = async (check) => {
    try {
      console.log('check', check);
      setType(check);
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <>
      <Select
        showSearch
        placeholder="Compagnie"
        optionFilterProp="children"
        allowClear={true}
        onChange={onFilter}
        filterOption={(input, option) =>
          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }>
        {operators &&
          operators.length > 0 &&
          operators.map((option, index) => {
            return (
              <Option key={`${option.id}_${option.title}`} value={option.id}>
                {option.title}
              </Option>
            );
          })}
      </Select>
      <br />
      <br />
      <Row gutter={[8, 8]} justify={'space-around'} wrap>
        <Col
          xs={{ span: 12 }}
          sm={{ span: 12 }}
          md={{ span: 6 }}
          lg={{ span: 6 }}>
          <Card
            bordered
            style={
              type === chartType.REVENUE
                ? {
                    backgroundColor: '#15bc8c0f',
                    boxShadow: '#15bc8c 0px 0px 5px',
                    border: '1px solid #15bc8c',
                    height: '100%',
                  }
                : {
                    height: '100%',
                  }
            }
            hoverable={true}
            onClick={() => onChangeType(chartType.REVENUE)}>
            <Spin spinning={loadingStats}>
              <Space
                direction="vertical"
                style={{ minWidth: '75px', width: '100%' }}>
                <Text style={{ fontWeight: 'bold' }}>
                  <IntlMessage id="global.revenue" /> (CFA)
                </Text>
                <Flex justify="space-between" wrap>
                  <Text>Aujourd'hui </Text>
                  <Text strong style={fs_16}>
                    {formatNumber(total?.day?.revenue ?? 0)}
                  </Text>
                </Flex>
                <Flex justify="space-between" wrap>
                  <Text>{dayjs().format('MMMM')} </Text>
                  <Text strong style={fs_16}>
                    {formatNumber(total?.month?.revenue ?? 0)}
                  </Text>
                </Flex>
              </Space>
            </Spin>
          </Card>
        </Col>
        <Col
          xs={{ span: 12 }}
          sm={{ span: 12 }}
          md={{ span: 6 }}
          lg={{ span: 6 }}>
          <Card
            bordered
            style={
              type === chartType.PASSENGERS
                ? {
                    backgroundColor: '#15bc8c0f',
                    boxShadow: '#15bc8c 0px 0px 5px',
                    border: '1px solid #15bc8c',
                    height: '100%',
                  }
                : {
                    height: '100%',
                  }
            }
            hoverable={true}
            onClick={() => onChangeType(chartType.PASSENGERS)}>
            <Spin spinning={loadingStats}>
              <Space
                direction="vertical"
                style={{ minWidth: '75px', width: '100%' }}>
                <Text style={{ fontWeight: 'bold' }}>
                  <IntlMessage id="global.passengers" />
                </Text>
                <Flex justify="space-between" wrap>
                  <Text>Aujourd'hui </Text>
                  <Text strong style={fs_16}>
                    {' '}
                    {formatNumber(total?.day?.total_seat ?? 0)}
                  </Text>
                </Flex>
                <Flex justify="space-between" wrap>
                  <Text>{dayjs().format('MMMM')}</Text>
                  <Text strong style={fs_16}>
                    {' '}
                    {formatNumber(total?.month?.total_seat ?? 0)}
                  </Text>
                </Flex>
              </Space>
            </Spin>
          </Card>
        </Col>
        <Col
          xs={{ span: 12 }}
          sm={{ span: 12 }}
          md={{ span: 6 }}
          lg={{ span: 6 }}>
          <Card
            bordered
            style={
              type === chartType.FILLING_RATE
                ? {
                    backgroundColor: '#15bc8c0f',
                    boxShadow: '#15bc8c 0px 0px 5px',
                    border: '1px solid #15bc8c',
                    height: '100%',
                  }
                : {
                    height: '100%',
                  }
            }
            hoverable={true}
            onClick={() => onChangeType(chartType.FILLING_RATE)}>
            <Spin spinning={loadingStats}>
              <Space
                direction="vertical"
                style={{ minWidth: '75px', width: '100%' }}>
                <Text style={{ fontWeight: 'bold' }}>
                  <IntlMessage id="global.filling_rate" />
                </Text>
                <Flex justify="space-between" wrap>
                  <Text>Aujourd'hui </Text>
                  <Text strong style={fs_16}>
                    {' '}
                    {`${Number(total.day.filling_rate)} %`}
                  </Text>
                </Flex>
                <Flex justify="space-between" wrap>
                  <Text>{dayjs().format('MMMM')}</Text>
                  <Text strong style={fs_16}>{`${Number(
                    total.month.filling_rate,
                  )} %`}</Text>
                </Flex>
              </Space>
            </Spin>
          </Card>
        </Col>
        <Col
          xs={{ span: 12 }}
          sm={{ span: 12 }}
          md={{ span: 6 }}
          lg={{ span: 6 }}>
          <Card
            bordered
            style={
              type === chartType.TRIPS
                ? {
                    backgroundColor: '#15bc8c0f',
                    boxShadow: '#15bc8c 0px 0px 5px',
                    border: '1px solid #15bc8c',
                    height: '100%',
                  }
                : {
                    height: '100%',
                  }
            }
            hoverable={true}
            onClick={() => onChangeType(chartType.TRIPS)}>
            <Spin spinning={loadingStats}>
              <Space
                direction="vertical"
                style={{ minWidth: '75px', width: '100%' }}>
                <Text style={{ fontWeight: 'bold' }}>
                  <IntlMessage id="global.trips" />
                </Text>
                <Flex justify="space-between" wrap>
                  <Text>Aujourd'hui </Text>
                  <Text strong style={fs_16}>
                    {formatNumber(total?.day?.total_count ?? 0)}
                  </Text>
                </Flex>
                <Flex justify="space-between" wrap>
                  <Text>{dayjs().format('MMMM')} </Text>
                  <Text strong style={fs_16}>
                    {formatNumber(total?.month?.total_count ?? 0)}
                  </Text>
                </Flex>
              </Space>
            </Spin>
          </Card>
        </Col>
      </Row>
      <Row gutter={[24, 24]} style={{ marginTop: 36 }}>
        <Col xl={16} lg={24} md={24} sm={24} xs={24} className="gx-order-lg-1">
          <RevenueChart operator={operator} type={type} />
        </Col>

        <Col xl={8} lg={24} md={24} sm={24} xs={24} className="gx-order-lg-2">
          <Widget>
            <RecentActivity
              recentList={dataRecent}
              onLoadMore={handleLoadMore}
            />
          </Widget>
        </Col>
      </Row>
    </>
  );
}

// export const recentActivity = [
//   {
//     id: 1,
//     day: "Today",
//     tasks: [
//       {
//         id: 1,
//         name: "Mila Alba",
//         title: [
//           <span className="gx-link" key={1}>
//             Mila Alba
//           </span>,
//           " left a 5 star review on ",
//           <span className="gx-link" key={2}>
//             Albama’s House
//           </span>,
//         ],
//         avatar: "https://via.placeholder.com/150x150",
//         imageList: [],
//       },
//       {
//         id: 2,
//         name: "Bob Builder",
//         title: [
//           "Callback request from ",
//           <span key={3} className="gx-link">
//             Bob Builder
//           </span>,
//           " for the property ",
//           <span className="gx-link" key={4}>
//             Dimitri House
//           </span>,
//         ],
//         avatar: "https://via.placeholder.com/150x150",
//         imageList: [],
//       },
//       {
//         id: 3,
//         name: "Tom Moody",
//         title: [
//           "Congratulations to ",
//           <span key={5} className="gx-link">
//             Tom Moody
//           </span>,
//           " for joining 10+ club ",
//         ],
//         avatar: "https://via.placeholder.com/150x150",
//         imageList: [],
//       },
//       {
//         id: 4,
//         name: "Norman Dolphi",
//         title: ["Norman Dolphi is looking for a house in New Jersy, USA"],
//         avatar: "",
//         imageList: [],
//       },
//     ],
//   },
//   // {
//   //   id: 2,
//   //   day: 'Yesterday',
//   //   tasks: [
//   //     {
//   //       id: 5,
//   //       name: 'Kily Johns',
//   //       title: ['Agent ',
//   //         <span key={6} className="gx-link">Kily Johns</span>, ' has added 7 new photos to the property ',
//   //         <span key={7} className="gx-link">Albama’s House</span>],
//   //       avatar: '',
//   //       imageList: ['https://via.placeholder.com/150x150', 'https://via.placeholder.com/150x150', 'https://via.placeholder.com/150x150'],
//   //     },
//   //     {
//   //       id: 6,
//   //       name: 'Tom Moody',
//   //       title: ['Welcome to a new agent ', <span className="gx-link" key={8}>Tom Moody in the Company</span>],
//   //       avatar: 'https://via.placeholder.com/150x150',
//   //       imageList: [],
//   //     },
//   //     {
//   //       id: 7,
//   //       name: 'Oliver Shorter',
//   //       title: [<span key={9} className="gx-link">Oliver Shorter</span>, ' is looking for an office space in ',
//   //       <span key={10} className="gx-link">Colorado, USA</span>],
//   //       avatar: 'https://via.placeholder.com/150x150',
//   //       imageList: [],
//   //     }
//   //   ]
//   // }
// ];
